import React, { useEffect, useState } from 'react';
import { Button } from '@asigna/kit';
import { ModalCloseButton } from 'components';
import { OwnerAvatar } from 'components/OwnerAvatar';
import useAddress from 'hooks/use-address';
import CheckedIcon from 'images/checked.svg';
import UncheckedIcon from 'images/unchecked.svg';
import { useAtom } from 'jotai';
import { contactsAtom } from 'store';
import { IContact, Owner } from 'types';
import { shortenAddress } from 'utils/helper';

interface AdderssBookDialogProps {
  handleClose: () => void;
  onConfirm: (contacts: IContact[]) => void;
  singleSelect?: boolean;
  passedInContacts?: Owner[];
}

// TODO_R: [RCC]
// TODO_R: [FRS] имя файла стилей
export const AddressBookDialog = (props: AdderssBookDialogProps) => {
  const { handleClose, onConfirm, singleSelect = false, passedInContacts } = props;
  const [contacts] = useAtom(contactsAtom);
  const [multiSelectedContacts, setMultiSelectedContacts] = useState<boolean[]>([]);
  const [singleSelectedContactIndex, setSingleSelectedContactIndex] = useState(0);
  const walletAccount = useAddress();

  useEffect(function preselectContacts() {
    const preselectedContacts: boolean[] = [];
    contacts.forEach((contact, index) => {
      const precheckedItem = passedInContacts?.findIndex(
        (precheckedContact) => precheckedContact.address === contact.contact_address
      );
      if (precheckedItem !== -1) {
        if (!singleSelect) {
          preselectedContacts[index] = true;
        } else {
          preselectedContacts[index] = false;
        }
      }
    });
    setMultiSelectedContacts([...preselectedContacts]);
  }, []);

  // TODO_R: заменить for loop
  const handleConfirm = async () => {
    const addedContacts: Array<any> = [];
    if (!singleSelect) {
      for (let i = 0; i < contacts.length; i++) {
        if (multiSelectedContacts[i]) {
          addedContacts.push(contacts[i]);
        }
      }
    } else {
      addedContacts.push(contacts[singleSelectedContactIndex]);
    }
    onConfirm(addedContacts);
    handleClose();
  };

  const getIcon = (index: number) => {
    if (!singleSelect) {
      return multiSelectedContacts[index] ? CheckedIcon : UncheckedIcon;
    } else {
      return index === singleSelectedContactIndex ? CheckedIcon : UncheckedIcon;
    }
  };

  const onCheck = (index: number) => {
    if (!singleSelect) {
      multiSelectedContacts[index] = !multiSelectedContacts[index];
      setMultiSelectedContacts([...multiSelectedContacts]);
    } else {
      setSingleSelectedContactIndex(index);
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-r20 text-white">Add from Contacts</h2>
        <ModalCloseButton onClick={handleClose} />
      </div>
      <div className="flex flex-col gap-8 my-8 max-h-[44vh] overflow-y-auto mx-[-20px] sm:mx-[-24px]">
        {contacts
          .filter((contact) => contact.contact_address !== walletAccount)
          .map((item, index) => {
            return (
              <div
                key={item.contact_address}
                className="flex w-full items-center gap-8 px-20 py-8 hover:bg-white-10 transition-all"
                onClick={() => onCheck(index)}
              >
                <OwnerAvatar address={item.contact_address} size="36px" index={index} />
                <p className="text-m12 text-white ml-4">{item.contact_name}</p>
                <p className="text-r12 text-regular ml-auto">
                  {shortenAddress(item.contact_address)}
                </p>
                <img src={getIcon(index)} alt="" />
              </div>
            );
          })}
      </div>
      <Button fullWidth onClick={handleConfirm} message="Confirm" colorType="primary" />
    </div>
  );
};
